// extracted by mini-css-extract-plugin
export default {"productDescription":"kca-z","featuredDescription":"lca-z","description":"mca-z","more":"nca-z","descriptionSku":"oca-z"};